// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2OdKy","placeholdersHeader":"styles_placeholdersHeader__3DT7e","editorStyle":"styles_editorStyle__3poGP","placeholdersBox":"styles_placeholdersBox__3WdBW"};